import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { Photos, Videos, Panoramas, Description, WalkingPhotos } from '.'
import { useMediaDetails } from 'Hooks/useMediaDetails'
import { getWalkingPoints } from 'Hooks/getWalkingPoints'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface SupplementalMediaProps {
  stopId?: number
  mainMediaId?: number
}

const SupplementalMedia = ({ stopId, mainMediaId }: SupplementalMediaProps) => {
  const {
    photos,
    photoAssetUrl,
    videos,
    panoramas,
    panoAssetUrl,
    photoHotspots,
    videoHotspots,
    panoHotspots,
    textHotspots,
    photoPosMedia,
    videoPosMedia,
    panoPosMedia,
  } = useMediaDetails(stopId)

  const { walkingPoints } = getWalkingPoints(stopId)

  const combinedPhotos =
    photos && photoHotspots && photoPosMedia
      ? [...photos, ...photoHotspots, ...photoPosMedia]
      : []
  const combinedVideos =
    videos && videoHotspots && videoPosMedia
      ? [...videos, ...videoHotspots, ...videoPosMedia]
      : []
  const combinedPanoramas =
    panoramas && panoHotspots && panoPosMedia
      ? [...panoramas, ...panoHotspots, ...panoPosMedia]
      : []

      console.log('Combined Photos:', combinedPhotos)

  const filteredPanoramas = mainMediaId
    ? combinedPanoramas.filter((item: any) => item.id !== mainMediaId)
    : combinedPanoramas

  const filteredPhotos = mainMediaId
    ? combinedPhotos.filter((item: any) => item.photoid !== mainMediaId)
    : combinedPhotos

  return (
    <>
      {filteredPhotos.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Photos
          </AccordionSummary>
          <AccordionDetails>
            <Photos photos={filteredPhotos} assetUrl={photoAssetUrl} />
          </AccordionDetails>
        </Accordion>
      )}

      {combinedVideos.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Videos
          </AccordionSummary>
          <AccordionDetails>
            <Videos videos={combinedVideos} />
          </AccordionDetails>
        </Accordion>
      )}

      {filteredPanoramas.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Panoramas
          </AccordionSummary>
          <AccordionDetails>
            <Panoramas panoramas={filteredPanoramas} assetUrl={panoAssetUrl} />
          </AccordionDetails>
        </Accordion>
      )}

      {textHotspots?.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Descriptions
          </AccordionSummary>
          <AccordionDetails>
            <Description hotspots={textHotspots} />
          </AccordionDetails>
        </Accordion>
      )}

      {walkingPoints.stopPoints.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Walking Points
          </AccordionSummary>
          <AccordionDetails>
            <p tabIndex={0}>You are now walking to the next stop experience.</p>
            <WalkingPhotos
              walkingPoints={walkingPoints}
              assetUrl={photoAssetUrl}
            />
          </AccordionDetails>
        </Accordion>
      )}
    </>
  )
}

export default SupplementalMedia
